import { _carrotEnglishAxios } from "@/plugins/carrotEnglishAxios";

const getByIdPlatform = (param) => {
  return _carrotEnglishAxios.get(`/rest_free/common/getByIdPlatform?email=${param.email}`);
};

export { getByIdPlatform };
